<template>
    <div class="well well-sm">
        <div class="row">
            <div class="col-sm-6 col-md-8 pt-2 pb-2">
                <h4>
                    {{ga.name}}
                </h4>
<!--                <div v-if="user.title">{{user.title}}</div>-->
<!--                <div v-if="user.email">-->
<!--                    <font-awesome-icon icon="envelope"></font-awesome-icon>-->
<!--                    {{user.email}}-->
<!--                    <br/>-->
<!--                </div>-->
<!--                <div v-if="user.phone">-->
<!--                    <font-awesome-icon icon="phone"></font-awesome-icon>-->
<!--                    {{user.phone | phone}}-->
<!--                    <br/>-->
<!--                </div>-->
<!--                <div v-if="user.fax">-->
<!--                    <font-awesome-icon icon="fax"></font-awesome-icon>-->
<!--                    {{user.fax | phone}}-->
<!--                </div>-->
            </div>
        </div>
        <div class="row mt-2 pb-2 pr-2 float-right">
            <div class="col-sm-12">
                <b-button to="/dashboard/general-agent/add/producer">Add Producer</b-button>
                <b-dropdown text="Options">
                    <b-dropdown-item to="/dashboard/ga/update">Change Info</b-dropdown-item>
                    <b-dropdown-item>Update License</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</template>

<script>
    export default {
        name: 'GaCard',
        props: ['ga']
    }
</script>


<style scoped>
    .well {
        background: #F9F9F9
    }

    .glyphicon {
        margin-bottom: 10px;
        margin-right: 10px;
    }

    small {
        display: block;
        line-height: 1.428571429;
        color: #999;
    }
</style>
